export default __webpack_public_path__ + "static/media/ClosePadlock.64d067b8.svg";